<template>
    <div :id="rootElementId" :style="`height:${heightComputed}px`" v-bind:class="{'d-flex justify-center':!embed}"></div>
</template>

<script>
import { getDataUrl } from "../../utils/functions";
export default {
  name: "PlayerAvatarMedia",
  computed: {
    rootElementId() {
      return `playerAvatarMedia${this.id}`;
    },
    darkMode(){
      return this.$vuetify.theme.dark;
    },
    heightComputed(){
      return this.height > 50 ? this.height : 50;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown || this.$vuetify.breakpoint.mobile;
    }
  },
  props:{
    player:{
      type: Object,
      required: true
    },
    id:{
      required: true
    },
    height:{
      type:Number,
      default:100
    },
    width:{
      type: Number,
      default: 300
    },
    color:{
      type: String,
      default: "#3366FF"
    },
    bgColor:{
      type: String,
      default: "white"
    },
    margin:{
      type: Object,
      required: false
    },
    title:{
      type: String,
      default: ""
    },
    subtitle:{
      type: String,
      default: ""
    },
    textColor:{
      type: String,
      default: "#000000"
    },
    comparisonPlayerData:{
      type:Object,
      required: false
    },
    comparisonTitle:{
      type: String,
      default: ""
    },
    comparisonSubtitle:{
      type: String,
      default: ""
    },
    comparisonColor:{
      type: String,
      default: "#000000"
    },
    type:{
      type:String,
      default:"radar"
    },
    face:{
      type:String,
      required: false
    },
    nationalTeam:{
      type: Boolean,
      default: false
    },
    comparisonFace:{
      type:String,
      required: false
    },
    orientation:{
      type:String,
      default: "left"
    },
    lineDistance:{
      type:String,
      required: false
    },
    lineWeight:{
      type:String,
      required: false
    },
    avatarSize:{
      type:String,
      required: false
    },
    upperTextFontSize:{
      type: String,
      required:false
    },
    upperTextFontWeight:{
      type: String,
      default: "900"
    },
    lowerTextFontSize:{
      type: String,
      default: "14",
      required:false
    },
    lowerTextFontWeight:{
      type: String,
      default: "400"
    },
    team:{
      type: Object,
      required: false
    },
    teamMode:{
      type: Boolean,
      default: false
    },
    embed:{
      type: Boolean,
      default: false
    },
    fontFamily:{
      type: String,
      default: 'NeueMontreal'
    },
    comparisonLeague:{
      type: Object,
      required: false
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    embedFactor: {
      type: Number,
      default: 1
    }
  },
  watch: {
    "orientation": function(newVal, oldVal) {
      this.printD3();
    },
  },
  data() {
    return {
      images: {}
    };
  },
  mounted: function() {
    window.addEventListener("resize", this.onWindowResize);
    this.printD3();
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    printD3(force = false){
      if(force){
        this.images = {}
      }
      const scale = d3.scale.linear()
      .range([0.86, 0.92])
      .domain([650, 1000]);
      let SVG_WIDTH
      if(this.type === "radar" || this.type === "polar"){
        SVG_WIDTH = this.width * 0.85 > 350 ? this.width * scale(this.width) : 350;
      }else if(this.type === "lollipop"){
        SVG_WIDTH = this.width * 0.95;
      }else{
        SVG_WIDTH = this.width;
      }

      if(this.embed){
        SVG_WIDTH = this.width * this.embedFactor;
      }

      d3.select(`#${this.rootElementId}`).select("svg").remove();

      var svg = d3.select(`#${this.rootElementId}`).append("svg")
      .attr("width", SVG_WIDTH)
      .attr("height", this.heightComputed)
      .style("fill", this.darkMode ? "cfcfcf" : "black")
      .style("background", this.bgColor)
      .attr("class", "playerAvatarMedia")
      .attr("id",`${this.rootElementId}SVG`)

      //If has comparison item and comparison player != main player OR comparison team != main team
      if(this.comparisonPlayerData && (this.comparisonPlayerData.playerName != this.player.name || this.comparisonPlayerData.teamName != this.team.teamName)){
        this.drawComparisonLeft(svg,SVG_WIDTH);
        this.drawComparisonRight(svg,SVG_WIDTH);
      }else{
        this.drawCenter(svg,SVG_WIDTH);
      }
    },
    drawImageBase64(svg,x,y,width,height,img,className,idName,bottom = false,extraParams={}) {
      if(!this.images[idName]){
        let base_image = new Image();
        base_image.crossOrigin = "anonymous";
        base_image.src = img;
        base_image.onload = (event) => {
          const dataUrl = getDataUrl(event.currentTarget);
          this.drawImage(
          svg,
          x,
          y,
          width,
          height,
          dataUrl,
          className,
          idName,
          bottom,
          extraParams
          );
        }
      }else{
        if(bottom){
          svg.node().insertBefore(this.images[idName],svg.node().firstChild);
        }else{
          svg.node().appendChild(this.images[idName]);
        }
      }
    },
    drawImage: function(svg, x, y, width, height, img,className,idName,bottom = false,extraParams={}) {
      let imgNode = bottom ? svg.insert("svg:image",":first-child") : svg.append("svg:image");
        imgNode.attr("x", x - (width / 2))
        .attr("y",  y - (height / 2))
        .attr("width", width)
        .attr("height", height)
        .attr("xlink:href", img)
        .attr("class",className)
        _.forEach(extraParams,(value,key) => {
          imgNode.attr(key,value);
        })
      this.images[idName] = imgNode.node().cloneNode(true);
    },
    drawRectangle(svg, x, y, width, height, color, opacity, className) {
      svg.append("rect")
        .attr("class", className)
        .attr("x", x)
        .attr("y", y)
        .attr("width", width)
        .attr("height", height)
        .style("fill", color)
        .style("opacity", opacity);
    },
    drawLine(svg, x, y, distance,size, color, opacity, className) {
      svg.append('line')
        .attr("class", className)
        .style("stroke", color)
        .style("stroke-width", size)
        .attr("x1", x - (distance/2))
        .attr("y1", y)
        .attr("x2", x + (distance/2))
        .attr("y2", y)
        .style("opacity", opacity);
    },
    drawCircle(svg, x, y, radius, fillColor,borderColor,borderSize, opacity, className) {
      return svg.append("circle")
        .attr("class", className)
        .attr("r", radius)
        .attr("cx", x)
        .attr("cy", y)
        .style("fill", fillColor)
        .style("stroke", borderColor)
        .style("stroke-width", borderSize)
        .style("opacity", opacity);
    },
    drawText(svg,x,y,color,fontSize,fontWeight,text,anchor="middle"){
      return svg.append("text")
      .attr("x",x)
      .attr("y",y)
      .attr("fill", color)
      .attr("font-size", fontSize)
      .attr("font-family", this.fontFamily)
      .attr("font-weight", fontWeight)
      .style("text-anchor",anchor)
      .text(text);
    },
    onWindowResize(){
      setTimeout(() => this.printD3(true), 100);
    },
    drawCenter(svg,SVG_WIDTH){
      //INI --- DRAW
      //CENTRAL LINE
      let lineX = (SVG_WIDTH/2) + 10;
      let lineY = this.heightComputed/2;
      let lineSize = this.lineWeight ? this.lineWeight : 2;
      let lineDistance = this.lineDistance ? this.lineDistance : SVG_WIDTH*0.4;
      this.drawLine(svg,lineX,lineY,lineDistance,lineSize,this.color,1,"")

      //CIRCLE AND PLAYER IMAGE
      let urlImg =  this.teamMode ? `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.team.teamId}.png` : `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
      let avatarSizeOffset = 6.61;
      let sizeImg = this.avatarSize ? this.avatarSize : (lineDistance/3.75) + avatarSizeOffset;
      let avatarRadius = (sizeImg)/2;
      let avatarX = this.orientation === 'left' ?  lineX - (lineDistance/2) - avatarRadius : lineX + (lineDistance/2) + avatarRadius;
      let avatarY = lineY;
      this.drawCircle(svg,avatarX,avatarY,avatarRadius,"transparent",this.color,lineSize,1,"")
      let clipPath = svg.append("clipPath").attr("id",`img-mask-circle-${this.rootElementId}`);
      this.drawCircle(clipPath,avatarX,avatarY,avatarRadius,"transparent","",lineSize,1,"")
      if(!this.face){
        this.drawImageBase64(svg,avatarX,avatarY + 2,sizeImg,sizeImg,urlImg,"playerAvatarImage","playerAvatarImage",true,{"clip-path":`url(#img-mask-circle-${this.rootElementId})`});
      }else{
        this.drawImageBase64(svg,avatarX,avatarY,sizeImg,sizeImg,this.face,"playerAvatarImage","playerAvatarImage",true,{"clip-path":`url(#img-mask-circle-${this.rootElementId})`})
      }

      //TEAM IMAGE
      if(!this.teamMode){
        let imgId = this.nationalTeam ? this.player.nationalTeamId : this.player.teamId;
        let className, idName = this.nationalTeam ? "nationalTeamAvatarImage" : "teamAvatarImage";
        let urlTeamImg = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${imgId}.png`;
        let sizeTeamImg = sizeImg * 0.55;
        let teamImgX = this.orientation === 'left' ?  avatarX + avatarRadius + 6 : avatarX - avatarRadius - 6;
        this.drawImageBase64(svg,teamImgX,avatarY,sizeTeamImg,sizeTeamImg,urlTeamImg,className,idName);
      }

      //PLAYER NAME
      let multiplier = 22;
      if (this.isMobile) {
        multiplier = this.isVertical ? 30 : 19;
      }
      if (this.embed && this.isVertical) {
        multiplier = 12;
      }
      const upperTextSize = this.upperTextFontSize ? this.upperTextFontSize : (this.width * multiplier) / 600;
      
      let playerNameText = this.drawText(svg,lineX,lineY - (avatarRadius/2.5),this.textColor,upperTextSize,this.upperTextFontWeight,this.title ? this.title : this.player.name);
      let playerNameSplitted = _.split(this.title ? this.title : this.player.name," ");
      let attempts = 0;
      while(attempts < 4 && playerNameText[0][0].getBoundingClientRect().width > (lineDistance - 50)){
        playerNameSplitted.shift()
        playerNameText.text(_.join(playerNameSplitted," "));
        attempts++;
      }
      const subtitleFontSize = this.embed ? this.lowerTextFontSize * 1.4 : (this.isMobile ? this.lowerTextFontSize * 0.8 : this.lowerTextFontSize * 1.3);
      let subtitleText = this.subtitle ? this.subtitle : this.$t("playerDetail.performance");
      let denominator;
      if (this.isMobile) {
        denominator = this.isVertical ? 1.1 : 1.2;
      }
      else {
        denominator = 1.2;
      }
      this.drawText(svg,lineX,lineY + (avatarRadius / denominator),this.textColor,subtitleFontSize,this.lowerTextFontWeight, subtitleText);
      //END --- DRAW
    },
    drawComparisonLeft(svg, SVG_WIDTH){
      let lineDistance = this.lineDistance ? this.lineDistance : SVG_WIDTH*0.3;
      let avatarSizeOffset = 6.61;
      let sizeImg = this.avatarSize ? this.avatarSize : (lineDistance/3.5) + avatarSizeOffset;
      let avatarRadius = (sizeImg)/2;
      //INI --- DRAW
      //LEFT LINE
      let lineX = 5 + (avatarRadius*2) + (lineDistance / 2);
      let lineY = this.heightComputed/2;
      let lineSize = this.lineWeight ? this.lineWeight : 2;
      this.drawLine(svg,lineX,lineY,lineDistance,lineSize,this.color,1,"")

      //CIRCLE AND MAIN PLAYER/TEAM IMAGE
      let urlImg = this.teamMode ? `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.team.teamId}.png` : `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
      let avatarX = lineX - (lineDistance/2) - avatarRadius;
      let avatarY = lineY;
      this.drawCircle(svg,avatarX,avatarY,avatarRadius,"transparent",this.color,lineSize,1,"")
      let clipPath = svg.append("clipPath").attr("id","img-mask-circle");
      this.drawCircle(clipPath,avatarX,avatarY,avatarRadius,"transparent","",lineSize,1,"")
      if(!this.face){
        this.drawImageBase64(svg,avatarX,avatarY + 2,sizeImg,sizeImg,urlImg,"playerAvatarImage","playerAvatarImage",true,{"clip-path":"url(#img-mask-circle)"});
      }else{
        this.drawImageBase64(svg,avatarX,avatarY,sizeImg,sizeImg,this.face,"playerAvatarImage","playerAvatarImage",true,{"clip-path":"url(#img-mask-circle)"})
      }

      //TEAM IMAGE
      if(!this.teamMode){
        let imgId = this.nationalTeam ? this.player.nationalTeamId : this.player.teamId;
        let className, idName = this.nationalTeam ? "nationalTeamAvatarImage" : "teamAvatarImage";
        let urlTeamImg = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${imgId}.png`;
        let sizeTeamImg = sizeImg * 0.55;
        let teamImgX = avatarX + avatarRadius + 6;
        this.drawImageBase64(svg,teamImgX,avatarY,sizeTeamImg,sizeTeamImg,urlTeamImg,className,idName);
      }

      //PLAYER NAME
      let upperTextSize = this.upperTextFontSize ? this.upperTextFontSize : (this.width * 22) / 600;
      if(upperTextSize > 22 && !this.upperTextFontSize){
        upperTextSize = 22;
      }
      let playerNameText = this.drawText(svg,lineX,lineY - 12,this.textColor,upperTextSize,this.upperTextFontWeight,this.title ? this.title : this.player.name);
      let playerNameSplitted = _.split(this.title ? this.title : this.player.name," ");
      let attempts = 0;
      while(attempts < 4 && playerNameText[0][0].getBoundingClientRect().width > (lineDistance - 50)){
        playerNameSplitted.shift()
        playerNameText.text(_.join(playerNameSplitted," "));
        attempts++;
      }
      let lowerTextSize = this.lowerTextFontSize ? this.lowerTextFontSize : (this.width * 12) / 475;
      if(lowerTextSize > 14 && !this.lowerTextFontSize){
        lowerTextSize = 14;
      }
      let subtitleText = this.subtitle ? this.subtitle : this.$t("playerDetail.performance");
      this.drawText(svg,lineX,lineY + 22,this.textColor,lowerTextSize,this.lowerTextFontWeight, subtitleText);
      //END --- DRAW
    },
    drawComparisonRight(svg, SVG_WIDTH){
      let lineDistance = this.lineDistance ? this.lineDistance : SVG_WIDTH*0.3;
      let avatarSizeOffset = 6.61;
      let sizeImg = this.avatarSize ? this.avatarSize : (lineDistance/3.5) + avatarSizeOffset;
      let avatarRadius = (sizeImg)/2;
      //INI --- DRAW
      //RIGHT LINE
      let lineX = (SVG_WIDTH - 5) - (avatarRadius*2) - (lineDistance / 2);
      let lineY = this.heightComputed/2;
      let lineSize = this.lineWeight ? this.lineWeight : 2;
      this.drawLine(svg,lineX,lineY,lineDistance,lineSize,this.comparisonColor,1,"")

      //CIRCLE AND COMPARE PLAYER/TEAM IMAGE
      let urlImg = this.teamMode ? `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.comparisonPlayerData.teamId}.png` : `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.comparisonPlayerData.playerId}.png`;
      urlImg = this.comparisonLeague ? `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${this.comparisonLeague.leagueId}.png` : urlImg;
      let avatarX = lineX + (lineDistance/2) + avatarRadius;
      let avatarY = lineY;
      this.drawCircle(svg,avatarX,avatarY,avatarRadius,"transparent",this.comparisonColor,lineSize,1,"")
      let clipPath = svg.append("clipPath").attr("id","img-comparison-mask-circle");
      this.drawCircle(clipPath,avatarX,avatarY,avatarRadius,"transparent","",lineSize,1,"")
      if(!this.comparisonFace){
        this.drawImageBase64(svg,avatarX,avatarY + 2,sizeImg,sizeImg,urlImg,"playerAvatarImage","comparisonPlayerAvatarImage",true,{"clip-path":"url(#img-comparison-mask-circle)"});
      }else{
        this.drawImageBase64(svg,avatarX,avatarY,sizeImg,sizeImg,this.comparisonFace,"playerAvatarImage","comparisonPlayerAvatarImage",true,{"clip-path":"url(#img-comparison-mask-circle)"})
      }

      //TEAM IMAGE
      if(!this.teamMode){
        let imgId = this.nationalTeam ? this.comparisonPlayerData.nationalTeamId : this.comparisonPlayerData.teamId;
        if(imgId){
          let className = this.nationalTeam ? "nationalTeamAvatarImage" : "teamAvatarImage";
          let idName = this.nationalTeam ? "comparisonNationalTeamAvatarImage" : "comparisonTeamAvatarImage";
          let urlTeamImg = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${imgId}.png`;
          let sizeTeamImg = sizeImg * 0.55;
          let teamImgX = avatarX - avatarRadius -6;
          this.drawImageBase64(svg,teamImgX,avatarY,sizeTeamImg,sizeTeamImg,urlTeamImg,className,idName);
        }
      }

      //PLAYER NAME
      let upperTextSize = this.upperTextFontSize ? this.upperTextFontSize : (this.width * 22) / 600;
      if(upperTextSize > 22 && !this.upperTextFontSize){
        upperTextSize = 22;
      }
      let playerNameText = this.drawText(svg,lineX,lineY - 12,this.textColor,upperTextSize,this.upperTextFontWeight,this.comparisonTitle ? this.comparisonTitle : this.comparisonPlayerData.playerName);
      let playerNameSplitted = _.split(this.comparisonTitle ? this.comparisonTitle : this.comparisonPlayerData.playerName," ");
      let attempts = 0;
      while(attempts < 4 && playerNameText[0][0].getBoundingClientRect().width > (lineDistance - 50)){
        playerNameSplitted.shift()
        playerNameText.text(_.join(playerNameSplitted," "));
        attempts++;
      }
      let lowerTextSize = this.lowerTextFontSize ? this.lowerTextFontSize : (this.width * 12) / 475;
      if(lowerTextSize > 14 && !this.lowerTextFontSize){
        lowerTextSize = 14;
      }
      let comparisonSubtitleText = this.comparisonSubtitle ? this.comparisonSubtitle : this.$t("playerDetail.performance");
      this.drawText(svg,lineX,lineY + 22,this.textColor,lowerTextSize,this.lowerTextFontWeight, comparisonSubtitleText);
      //END --- DRAW
    },
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/player/PlayerAvatarMedia.vue